<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import UserPresenter from '@satellite/components/elements/presenters/user/UserPresenter.vue';
import useYardTaskCommentEvent from './useYardTaskCommentEvent';

import type { YardTaskTimelineEvent } from '@satellite/composables/useYardTaskTimeline';

interface Props {
  event: YardTaskTimelineEvent;
  timezone: string;
  locale: string;
}

const props = defineProps<Props>();

const { t } = useI18n();
const { formattedCreatedTime, user, htmlContent } = useYardTaskCommentEvent(props.event, {
  timezone: props.timezone,
  locale: props.locale
});
</script>

<template>
  <div class="d-flex flex-column gap-2 align-start justify-start">
    <div class="d-flex flex-column gap-0-5 align-start justify-start">
      <span class="d-flex flex-row flex-wrap align-center justify-start gap-1">
        <user-presenter
          v-if="user"
          class="typography-body-sm-bold text--color-text-secondary"
          :user="user"
          :display-fields="['name']" />
        <span class="typography-body-sm">{{ t('global.timeline.addedA') }}</span>
        <span class="typography-body-sm-bold text-lowercase">
          {{ t('global.basicTerms.comment') }}
        </span>
      </span>
      <span v-if="formattedCreatedTime" class="typography-caption text--color-text-tertiary">
        {{ formattedCreatedTime }}
      </span>
    </div>

    <div
      v-if="htmlContent"
      class="typography-body-sm text--color-text-secondary"
      style="white-space: pre-line">
      {{ htmlContent }}
    </div>
  </div>
</template>
